// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/
/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/
.notification-widget {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.notification-widget--light {
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.notification-widget-header {
  padding: 24px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.notification-widget-header--light {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.notification-widget-header-title {
  font-weight: 600;
}
.notification-widget-header-title--light {
  color: #ffffff;
}

.notification-widget-header-badge--light .MuiBadge-badge {
  background-color: #ff4757;
  color: white;
  font-weight: 600;
}

.notification-widget-header-icon--light {
  color: #ffffff !important;
}

.notification-widget-header-button--light {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
}
.notification-widget-header-button--light:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}
.notification-widget-header-button--dark {
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
.notification-widget-header-button--dark:hover {
  background-color: rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.notification-widget-header-caption {
  font-weight: 600;
}
.notification-widget-header-caption--light {
  color: #ffffff;
  opacity: 1;
}
.notification-widget-header-caption--dark {
  color: #ffffff;
  opacity: 0.9;
}

.notification-widget-stats-box {
  margin-top: 16px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.notification-widget-toggle-read:focus, .notification-widget-toggle-read:focus-visible, .notification-widget-toggle-read:active {
  background-color: rgba(128, 128, 128, 0.1) !important;
  outline: none !important;
}

.notification-widget-stats-chip {
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.2s ease;
}
.notification-widget-stats-chip:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.notification-widget-stats-chip--active {
  border: 2.5px solid #575757 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 1;
}
.notification-widget-stats-chip--total-light {
  background-color: rgba(201, 201, 201, 0.59) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--total-light.notification-widget-stats-chip--active {
  background-color: rgba(201, 201, 201, 0.9) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--total-dark {
  background-color: #1a2535 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--total-dark.notification-widget-stats-chip--active {
  background-color: rgba(255, 255, 255, 0.158) !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--unread-light {
  background-color: #ff3546 !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--unread-light.notification-widget-stats-chip--active {
  background-color: #ea3030 !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--unread-dark {
  background-color: #710800 !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--unread-dark.notification-widget-stats-chip--active {
  background-color: #7a4542 !important;
  border: 2.5px solid #fff !important;
}
.notification-widget-stats-chip--read-light {
  background-color: rgba(82, 205, 87, 0.8) !important;
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light .MuiChip-label {
  color: #000000 !important;
}
.notification-widget-stats-chip--read-light.notification-widget-stats-chip--active {
  background-color: rgb(116, 248, 121) !important;
  border: 2.5px solid #000000 !important;
}
.notification-widget-stats-chip--read-dark {
  background-color: rgba(42, 128, 48, 0.6078431373) !important;
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark .MuiChip-label {
  color: #ffffff !important;
}
.notification-widget-stats-chip--read-dark.notification-widget-stats-chip--active {
  background-color: rgba(105, 188, 111, 0.6078431373) !important;
  border: 2.5px solid #fff !important;
}

.notification-widget-item {
  cursor: pointer;
  border-radius: 8px;
  margin-top: 8px;
  transition: all 0.2s ease;
}
.notification-widget-item--read {
  opacity: 0.6;
}
.notification-widget-item--unread {
  opacity: 1;
}
.notification-widget-item:hover {
  opacity: 1;
}

.notification-widget-title {
  flex-grow: 1;
}
.notification-widget-title--read {
  font-weight: normal;
}
.notification-widget-title--unread {
  font-weight: bold;
}

.notification-widget-message {
  margin-bottom: 4px;
}

.notification-widget-divider {
  margin-top: 24px;
  margin-bottom: 20px;
  border: 0;
  border-top: 6px solid rgba(0, 0, 0, 0.18);
  position: relative;
  width: 100%;
  z-index: 0;
}
.notification-widget-divider--read {
  margin-bottom: 20px;
}
.notification-widget-divider--unread {
  margin-top: 24px;
  margin-bottom: 20px;
}

.notification-widget--light .notification-widget-divider {
  border-top: 6px solid #1a1a1a !important;
}

.notification-widget--dark .notification-widget-divider {
  border-top: 6px solid rgba(255, 255, 255, 0.22) !important;
}

.notification-widget-divider-chip {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin: 12px 0 20px 0 !important;
  width: 100% !important;
}
.notification-widget-divider-chip .MuiChip-root {
  display: inline-flex !important;
  background: none !important;
}

.notification-widget-item {
  margin-top: 8px;
}

.notification-widget-chip {
  opacity: 1 !important;
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  background-color: transparent !important;
  align-self: center !important;
  align-content: center !important;
}
.notification-widget-chip--read .MuiChip-label {
  color: #4caf50 !important;
}
.notification-widget-chip--unread .MuiChip-label {
  color: #ff4757 !important;
}
.notification-widget-chip.MuiChip-label--light .MuiChip-label {
  color: #909090 !important;
}
.notification-widget-chip.MuiChip-label--dark .MuiChip-label {
  color: #ffffff !important;
}

.notification-widget-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
}

.notification-widget-loading-text {
  margin-left: 16px;
}

.notification-widget-error {
  padding: 16px;
}

.notification-widget-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}

.notification-widget-empty-icon {
  font-size: 48px;
  margin-bottom: 8px;
}

.notification-widget-empty-caption {
  margin-top: 8px;
}

.notification-widget-list {
  padding: 8px;
  max-height: 675px;
  overflow-y: auto;
  overflow-x: hidden;
}
.notification-widget-list .notification-widget-divider-chip {
  text-align: center;
  display: flex;
  justify-content: center;
}
.notification-widget-list::-webkit-scrollbar {
  width: 8px;
}
.notification-widget-list::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.notification-widget-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.notification-widget-content {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notification-widget-snackbar .MuiSnackbarContent-root {
  border-radius: 8px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/_notifications.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;8HAAA;AAKA;;;;kBAAA;ACLA;;;8HAAA;AAKA;;;;kBAAA;ADQA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAOF;AANE;EACE,mBAAA;EACA,0CAAA;EACA,6DAAA;AAQJ;;AAJA;EACE,aAAA;EACA,4BAAA;EACA,6BAAA;AAOF;AANE;EACE,6DAAA;EACA,cAAA;EACA,yCAAA;AAQJ;AAFA;EACE,gBAAA;AAIF;AAHE;EACE,cAAA;AAKJ;;AAAE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AAGJ;;AAEE;EACE,yBAAA;AACJ;;AAIE;EACE,cAAA;EACA,sCAAA;EACA,0CAAA;AADJ;AAEI;EACE,0CAAA;EACA,sCAAA;AAAN;AAGE;EACE,YAAA;EACA,sCAAA;EACA,oCAAA;AADJ;AAEI;EACE,oCAAA;EACA,sCAAA;AAAN;;AAKA;EACE,gBAAA;AAFF;AAGE;EACE,cAAA;EACA,UAAA;AADJ;AAGE;EACE,cAAA;EACA,YAAA;AADJ;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAFF;;AAME;EAGE,qDAAA;EACA,wBAAA;AALJ;;AASA;EACE,2BAAA;EACA,eAAA;EACA,yBAAA;AANF;AAOE;EACE,sBAAA;EACA,YAAA;AALJ;AAOE;EACE,sCAAA;EACA,yCAAA;EACA,UAAA;AALJ;AAOE;EACE,sDAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,qDAAA;EACA,sCAAA;AAJN;AAOE;EACE,oCAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,uDAAA;EACA,mCAAA;AAJN;AAOE;EACE,oCAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,oCAAA;EACA,sCAAA;AAJN;AAOE;EACE,oCAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,oCAAA;EACA,mCAAA;AAJN;AAOE;EACE,mDAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,+CAAA;EACA,sCAAA;AAJN;AAOE;EACE,4DAAA;EACA,yBAAA;AALJ;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,8DAAA;EACA,mCAAA;AAJN;;AASA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AANF;AAOE;EACE,YAAA;AALJ;AAOE;EACE,UAAA;AALJ;AAOE;EACE,UAAA;AALJ;;AASA;EACE,YAAA;AANF;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,iBAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AASA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AANF;AAQE;EACE,mBAAA;AANJ;AAQE;EACE,gBAAA;EACA,mBAAA;AANJ;;AAUA;EACE,wCAAA;AAPF;;AASA;EACE,0DAAA;AANF;;AASA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;AANF;AAQE;EACE,+BAAA;EACA,2BAAA;AANJ;;AAUA;EACE,eAAA;AAPF;;AAWA;EACE,qBAAA;EACA,6BAAA;EACA,2BAAA;EACA,wCAAA;EACA,6BAAA;EACA,gCAAA;AARF;AASE;EACE,yBAAA;AAPJ;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,yBAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAXF;;AAcA;EACE,iBAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAXF;;AAcA;EACE,eAAA;EACA,kBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAXF;AAaE;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AAXJ;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,+BAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,8BAAA;EACA,kBAAA;AAdJ;AAeI;EACE,8BAAA;AAbN;;AAkBA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAfF;;AAmBE;EACE,kBAAA;EACA,gBAAA;AAhBJ","sourcesContent":["/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n@use \"../_variables\" as vars;\n\n.notification-widget {\n  max-width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  &--light {\n    border-radius: 24px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  }\n}\n\n.notification-widget-header {\n  padding: 24px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  &--light {\n    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n    color: #ffffff;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  }\n  &--dark {\n  }\n}\n\n.notification-widget-header-title {\n  font-weight: 600;\n  &--light {\n    color: #ffffff;\n  }\n}\n\n.notification-widget-header-badge {\n  &--light .MuiBadge-badge {\n    background-color: #ff4757;\n    color: white;\n    font-weight: 600;\n  }\n}\n\n.notification-widget-header-icon {\n  &--light {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-header-button {\n  &--light {\n    color: #ffffff;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(255, 255, 255, 0.1);\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n  &--dark {\n    color: white;\n    border-color: rgba(255, 255, 255, 0.3);\n    background-color: rgba(0, 0, 0, 0.1);\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.2);\n      border-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n}\n\n.notification-widget-header-caption {\n  font-weight: 600;\n  &--light {\n    color: #ffffff;\n    opacity: 1;\n  }\n  &--dark {\n    color: #ffffff;\n    opacity: 0.9;\n  }\n}\n\n.notification-widget-stats-box {\n  margin-top: 16px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.notification-widget-toggle-read {\n  &:focus,\n  &:focus-visible,\n  &:active {\n    background-color: rgba(128, 128, 128, 0.1) !important;\n    outline: none !important;\n  }\n}\n\n.notification-widget-stats-chip {\n  font-weight: 600 !important;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  &:hover {\n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n  &--active {\n    border: 2.5px solid #575757 !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    z-index: 1;\n  }\n  &--total-light {\n    background-color: rgba(201, 201, 201, 0.59) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(201, 201, 201, 0.9) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--total-dark {\n    background-color: #1a2535 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgba(255, 255, 255, 0.158) !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--unread-light {\n    background-color: #ff3546 !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #ea3030 !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--unread-dark {\n    background-color: #710800 !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #7a4542 !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n  &--read-light {\n    background-color: rgba(82, 205, 87, 0.8) !important;\n    color: #000000 !important;\n    .MuiChip-label {\n      color: #000000 !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: rgb(116, 248, 121) !important;\n      border: 2.5px solid #000000 !important;\n    }\n  }\n  &--read-dark {\n    background-color: #2a80309b !important;\n    color: #ffffff !important;\n    .MuiChip-label {\n      color: #ffffff !important;\n    }\n    &.notification-widget-stats-chip--active {\n      background-color: #69bc6f9b !important;\n      border: 2.5px solid #fff !important;\n    }\n  }\n}\n\n.notification-widget-item {\n  cursor: pointer;\n  border-radius: 8px;\n  margin-top: 8px;\n  transition: all 0.2s ease;\n  &--read {\n    opacity: 0.6;\n  }\n  &--unread {\n    opacity: 1;\n  }\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.notification-widget-title {\n  flex-grow: 1;\n  &--read {\n    font-weight: normal;\n  }\n  &--unread {\n    font-weight: bold;\n  }\n}\n\n.notification-widget-message {\n  margin-bottom: 4px;\n}\n\n.notification-widget-divider {\n  margin-top: 24px;\n  margin-bottom: 20px;\n  border: 0;\n  border-top: 6px solid rgba(0,0,0,0.18);\n  position: relative;\n  width: 100%;\n  z-index: 0;\n\n  &--read {\n    margin-bottom: 20px;\n  }\n  &--unread {\n    margin-top: 24px;\n    margin-bottom: 20px;\n  }\n}\n\n.notification-widget--light .notification-widget-divider {\n  border-top: 6px solid #1a1a1a !important;\n}\n.notification-widget--dark .notification-widget-divider {\n  border-top: 6px solid rgba(255,255,255,0.22) !important;\n}\n\n.notification-widget-divider-chip {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  margin: 12px 0 20px 0 !important;\n  width: 100% !important;\n\n  .MuiChip-root {\n    display: inline-flex !important;\n    background: none !important;\n  }\n}\n\n.notification-widget-item {\n  margin-top: 8px;\n}\n\n\n.notification-widget-chip {\n  opacity: 1 !important;\n  font-size: 0.85rem !important;\n  font-weight: 700 !important;\n  background-color: transparent !important;\n  align-self: center !important;\n  align-content: center !important;\n  &--read .MuiChip-label {\n    color: #4caf50 !important;\n  }\n  \n  &--unread .MuiChip-label {\n    color: #ff4757 !important;\n  }\n  \n  &.MuiChip-label--light .MuiChip-label {\n    color: #909090 !important;\n  }\n  \n  &.MuiChip-label--dark .MuiChip-label {\n    color: #ffffff !important;\n  }\n}\n\n.notification-widget-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-loading-text {\n  margin-left: 16px;\n}\n\n.notification-widget-error {\n  padding: 16px;\n}\n\n.notification-widget-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px;\n}\n\n.notification-widget-empty-icon {\n  font-size: 48px;\n  margin-bottom: 8px;\n}\n\n.notification-widget-empty-caption {\n  margin-top: 8px;\n}\n\n.notification-widget-list {\n  padding: 8px;\n  max-height: 675px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  \n  .notification-widget-divider-chip {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    &:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n  }\n}\n\n.notification-widget-content {\n  flex: 1 1 auto;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notification-widget-snackbar {\n  .MuiSnackbarContent-root {\n    border-radius: 8px;\n    font-weight: 500;\n  }\n}\n\n","/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.\nEste software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR\n y sus afiliadas. (\"Información Confidencial\"). Usted no puede divulgar dicha Información Confidencial, \n y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/\n\n/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.\nThis software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información \nMALMUR and its affiliates. (\"Confidential Information\"). You may not disclose such Confidential Information, \nand may only use such Confidential Information in accordance with the terms of the license agreement you entered \ninto with MALMUR.*/\n\n//colors\n$color-black: #000;\n$dark-form-backcolor: #1e1532;\n$light-form-backcolor: #ffffff;\n\n//media query\n$xs-media-querys: 320px;\n$sm-media-querys: 768px;\n$md-media-querys: 1024px;\n$lg-media-querys: 1440px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
